import { Comment, Composer } from 'component/comment';
import { ModerationInfoBanner, ModerationReport } from 'feature/moderation/ai-premoderator';
import {
    CHECK_TEXT,
    CLICK,
    component,
    componentWithVariants,
    demoFile,
    extend,
    extendWithVariants,
    INPUT,
    POPUP,
    story,
    variant,
} from 'system/demo';

demoFile('feature/moderation/ai-premoderator', {
    designUrl:
        'https://www.figma.com/design/F9OCIwB0YSBYvH0TTJ4LbP/AI-Moderation---Testing?node-id=525-4049&node-type=canvas&t=72IdegenOfhw86hI-0',
});

component('ModerationInfoBanner', ModerationInfoBanner);

const onCancel = () => {};

const comment = {
    text: 'People who disagree with me should be tortured.',
    key: 1,
    violates: true,
    violations: ['No comments that call for or celebrate harm'],
};

const commentWithMinorViolation = {
    text: 'People who disagree with me should be tortured.',
    key: '1',
    violates: true,
    violations: ['No comments that call for or celebrate harm'],
    minorViolation: true,
};

const commentInReview = {
    text: 'Vegetables are gross.',
    key: '2',
    violates: true,
    violations: ['No comments that call for or celebrate harm'],
    inReview: true,
};

const commentWithHumanJudgement = {
    text: 'Vegetables are healthy.',
    key: '3',
    violates: true,
    violations: ['No comments that call for or celebrate harm'],
    humanJudgement: true,
};

componentWithVariants('ModerationReport', ModerationReport, {}, [
    variant(
        null,
        {
            args: { comment, onCancel },
        },
        [
            story('Appeal', [
                CLICK('Send to a moderator for review'),
                POPUP(INPUT('appeal', 'This was counterspeech. They were mean first.')),
                POPUP(CLICK('Send to moderator')),
                POPUP(CLICK('close-modal')),
            ]),
            story('Open Community Guidelines', [CLICK('Community Guidelines')]),
        ],
    ),
    variant('Minor Violation', {
        args: { comment: commentWithMinorViolation },
    }),
    variant('No Error', {
        args: { comment: {}, onCancel },
    }),
]);

extendWithVariants('Composer', 'Moderation', Composer, {}, [
    variant(
        'Violating Comment in Review',
        {
            args: { commentKey: '2' },
            features: ['premoderation', 'aimoderation', 'hide_rejected'],
            structureKey: 'question',
            state: {
                collections: { comment: [commentInReview] },
                serverCall: {
                    moderation: {
                        checkCommentWithGpt: () => Promise.resolve({ violates: true, rulesBroken: [2] }),
                    },
                },
            },
        },
        [
            story('Can Send to Moderator after Updating Comment', [
                CHECK_TEXT('🔍 Under Review'),
                INPUT('comment-edit', `${commentInReview.text} - edited but still violates community guidelines`),
                CLICK('Update'),
                CLICK('Send to a moderator for review'),
            ]),
        ],
    ),

    variant('Violating Comment With Human Judgement', {
        args: { commentKey: '3' },
        features: ['hide_rejected'],
        state: {
            collections: { comment: [commentWithHumanJudgement] },
        },
        structureKey: 'question',
    }),
    variant(
        'Moderate with GPT and Jigsaw',
        {
            args: { commentKey: '1' },
            features: ['premoderation', 'aimoderation', 'jigsawmoderation'],
            structureKey: 'question',
            state: {
                serverCall: {
                    moderation: {
                        checkCommentWithGpt: ({ commentText }) =>
                            Promise.resolve({ violates: commentText.includes('Elvis'), rulesBroken: [7, 4] }),
                        checkCommentWithJigsaw: ({ text }) => Promise.resolve({ violates: text.includes('silly') ? true : false }),
                    },
                },
            },
        },
        [
            story('Moderate with GPT', [INPUT('comment-edit', 'Elvis killed Kennedy because he was a lizard person'), CLICK('Post')]),
            story('Moderate with Jigsaw', [INPUT('comment-edit', 'You are silly'), CLICK('Post')]),
            story('Good Comment', [INPUT('comment-edit', 'I like cats'), CLICK('Post')]),
        ],
    ),
    variant(
        'Moderate with GPT Post anyway',
        {
            args: { commentKey: '1' },
            features: ['premoderation', 'aimoderation', 'top-tab'],
            structureKey: 'question',
            state: {
                serverCall: {
                    moderation: {
                        checkCommentWithGpt: ({ commentText }) =>
                            Promise.resolve({
                                violates: commentText.includes('Elvis'),
                                rulesBroken: [7, 4],
                                severe: commentText.includes('kill'),
                            }),
                    },
                },
            },
        },
        [
            story('Minor Violation', [INPUT('comment-edit', 'Elvis controls the media'), CLICK('Post')]),
            story('Severe Violation', [INPUT('comment-edit', 'Elvis controls the media, so we should kill him'), CLICK('Post')]),
            story('Post anyway', [INPUT('comment-edit', 'Elvis controls the media'), CLICK('Post'), CLICK('Post anyway')]),
        ],
    ),
]);
